module.exports = __webpack_public_path__ + "static/img/home_bt4.6de0b2e3.png";